<template>
    <div id="app">
        <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
                <table class="zak">
                    <tbody>
                    <tr align="left">
                        <td valign="top">Телефон:</td>
                        <td>
                            <ValidationProvider name="Телефон" :rules="`${reqTel ? 'required' : ''}`"
                                                v-slot="{classes,errors}">
                                <div class="control" :class="classes">
                                    <PhoneFieldComponent @changeTelephone="onChangeTelephone"/>
                                    <span>{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </td>
                    </tr>
                    <tr align="left">
                        <td valign="top" colspan="2">Контактное лицо</td>
                    </tr>

                    <tr align="left">
                        <td valign="top">Фамилия</td>
                        <td>
                            <ValidationProvider name="Фамилия" rules="required|alpha" v-slot="{classes,errors}">
                                <div class="control" :class="classes">
                                    <input type="text"
                                           v-model="contact"
                                           name="contact"
                                    >
                                    <span>{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </td>
                    </tr>
                    <tr align="left">
                        <td valign="top">Имя<span class="reds">*</span></td>
                        <td>

                            <ValidationProvider name="Имя" rules="required|alpha" v-slot="{classes,errors}">
                                <div class="control" :class="classes">
                                    <input type="text"
                                           v-model="fname"
                                           name="fname"
                                    >
                                    <span>{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </td>
                    </tr>
                    <tr align="left">
                        <td valign="top">Отчество:</td>
                        <td>
                            <ValidationProvider name="Отчество" rules="required|alpha" v-slot="{classes,errors}">
                                <div class="control" :class="classes">
                                    <input type="text"
                                           name="fmiddlename"
                                           v-model="fmiddlename"
                                    >
                                    <span>{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </td>
                    </tr>

                    <tr align="left">
                        <td valign="top">E-mail:</td>
                        <td>
                            <ValidationProvider name="email" rules="required|email" v-slot="{classes,errors}">
                                <div class="control" :class="classes">
                                    <input v-model="email" type="text">
                                    <span>{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </td>
                    </tr>
                    <tr align="left">
                        <td valign="top">Ваш город:</td>
                        <td>
                            <ValidationProvider name="Ваш город:" rules="required"
                                                v-slot="{classes,errors}"
                            >
                                <div class="control" :class="classes">
                                    <input
                                            type="text"
                                            name="city"
                                            v-model="city"
                                    >
                                    <span>{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </td>
                    </tr>
                    <tr id="address" align="left">
                        <td valign="top">Способ оплаты:</td>
                        <td><div>
                            <select name="dopinfo" v-model="dopinfo" class="control">
                            <option value="n">Наличный расчет</option>
                            <option value="b">Безналичный расчет</option>
                        </select>
                        </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <input type="submit"
                       name="Submit" class="button" value=" ОТПРАВИТЬ ЗАКАЗ ">
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'App',
        data() {
            return {
                fname: '',
                contact: '',
                fmiddlename: '',
                email: '',
                city: '',
                phone: '',
                reqTel: true,
                dopinfo: 'n'
            };
        },
        methods: {
            onSubmit() {
                axios.post('//santehvalom.ru/cart/out', {
                    phone: this.phone,
                    contact: this.contact,
                    fname: this.fname,
                    fmiddlename: this.fmiddlename,
                    femail: this.femail,
                    email: this.email,
                    city: this.city,
                    dopinfo: this.dopinfo
                }).then(response => {
                     //console.log('s');
                    // this.response = response.data
                    // this.success = 'Data saved successfully';
                    this.response = JSON.stringify(response, null, 2);
                    window.location.href = '//santehvalom.ru/cart/outend';
                }).catch(error => {
                    this.response = 'Error: ' + error.response.status
                })

            },
            onChangeTelephone(data) {
                //console.log('=', data.match(/\d/g).length);
                console.log('@');
                this.reqTel = true;
                this.phone = data;
                if (data.match(/\d/g).length == 11) {
                    this.reqTel = false;
                    console.log('[@]');
                }
            }
        }
    }
</script>


<style scoped>
    .control {
        width: 100%;
    }

    .control span {
        display: block;
    }

    .control input,  select.control {
        padding: 5px 10px;
    }

    .control.invalid input{
        font-size: 13px;
        color: #eb0600;
    }
    .control.invalid span {
        font-size: 10px;
        color: #eb0600;
    }

    .control.invalid input {
        border: 1px #eb0600 solid;
    }

    .control.valid input{
        color: #045929;
        font-size: 13px;
    }
    .control.valid span {
        color: #045929;
        font-size: 10px;
    }

    .control.valid input {
        border: 1px #045929 solid;
    }
    .button{
        margin: 10px 0;
    }
</style>